import { defineStore } from 'pinia'
import TextCell from '@/onenetwork/components/datatable/TextCell.vue'
import ThumbCell from '@/onenetwork/components/datatable/ThumbCell.vue'
import MoneyCell from '@/onenetwork/components/datatable/MoneyCell.vue'
import NumberCell from '@/onenetwork/components/datatable/NumberCell.vue'
import DateTimeCell from '@/onenetwork/components/datatable/DateTimeCell.vue'
import KYCCell from '@/onenetwork/components/datatable/KYCCell.vue'
import { uuid } from 'vue3-uuid'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant.ts'
import AccountAPI from '@/modules/account/constants/account.api.uri.const.ts'
import {markRaw} from 'vue'

export interface tabItem {
  id: string,
  label: string,
  active: boolean,
}

export enum MembershipActionTypes {
  FILTERING = 'FILTERING',
  PENDING= "PENDING",
  FETCHING= "FETCHING",
  FETCH_SUCCESS = "FETCH_SUCCESS",
  FETCH_FAILURE = "FETCH_FAILURE",
}

interface MembershipListStore {
  action_type: MembershipActionTypes,
  action_mess: string,
  uuid: string,
  data: Object,
  filter: Object,
  pageSize: number,
  page: number,
  tabs: Array<any>,
  tableConfig: any,
  selectedIds: Array<string|number>,
}

export const useMembershipListStore = defineStore('system.membership', {
  state: (): MembershipListStore => ({
    action_type: MembershipActionTypes.PENDING,
    action_mess: "",
    uuid: '',
    data: {
      list: [],
      totalRecords: 0,
      totalPage: 0,
    },
    filter: [
      {
        key: 'keywords',
        type: 'taginput',
        label: 'Lọc theo từ khoá',
        placeholder: 'Nhập từ khoá',
        value: '',
      },
      {
        key: 'status',
        type: 'select-multiple',
        label: 'Tình trạng',
        placeholder: 'Chọn tình trạng',
        value: '',
        options: [
          { label: 'Tất cả', value: '' },
          { label: 'Đang hoạt động', value: 'live' },
          { label: 'Ngưng hoạt động', value: 'deprecated' },
        ],
      },
    ],
    pageSize: 10,
    page: 1,
    tabs: [
      {
        id: 'list',
        label: 'Danh sách các gói phí',
        active: true,
      }
    ],
    tableConfig: {
      canShowHide: true,
      columns: {
        status: { label: 'Trạng thái', component: markRaw(TextCell), visible: true, sort: false, class: '', config: {} },
        name: { label: 'Tên gói', component: markRaw(TextCell), visible: true, sort: false, class: '', config: {} },
        description: { label: 'Chú thích', component: markRaw(TextCell), visible: true, sort: false, class: '', config: {} },
        price: { label: 'Giá', component: markRaw(MoneyCell), visible: true, sort: false, class: 'justify-end', config: {} },
        period: { label: 'Thời gian sử dụng', component: markRaw(TextCell), visible: true, sort: false, class: '', config: {} },
        created_at: { label: 'Ngày tạo', component: markRaw(DateTimeCell), visible: true, sort: '', class: '', config: {} },
      }
    },
    selectedIds: []
  }),
  getters: {
    sortFilter: state => {
      const sort: any = []
      if(Object.keys(state.tableConfig?.columns).length>0){
        Object.keys(state.tableConfig?.columns).forEach(col => {
          if(state.tableConfig.columns[col].sort) {
            sort.push([col, state.tableConfig.columns[col].sort])
          }
        })
      }
      return sort
    }
  },
  actions: {
    //TAB ACTION
    changeTab (targetId: string) {

      for (const tab of this.tabs) {
        tab.active = (tab.id === targetId)
      }
    },
    closeTab (targetId: string) {
      const index = this.tabs.findIndex(tab => tab.id === targetId)
      if (index !== -1) {
        this.tabs.splice(index, 1)
      }
    },
    closeAllTab () {
      this.tabs = [{
        id: 'list',
        label: 'Danh sách phiên bản',
        active: true,
      }]
    },
    newTab (item: tabItem) {
      const exists = this.tabs.some(tab => tab.id === item.id)
      if (!exists) {
        this.tabs.push(item)
      }
      this.changeTab(item.id)
    },

    //FILTER ACTION
    setFilter (filter: any) {
      this.filter = filter
      this.action_type = MembershipActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //PAGE ACTION
    changePage (page: number) {
      this.page = page
      this.action_type = MembershipActionTypes.FILTERING
      this.uuid = uuid.v4()
    },
    changePageSize (size: number) {
      this.pageSize = size
      this.action_type = MembershipActionTypes.FILTERING
      this.uuid = uuid.v4()
    },

    //TABLE CONFIG ACTION
    toggleColumnVisibility(columnCode: string, visible: boolean) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].visible = visible
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },
    toggleSort(columnCode: string, sort: string) {
      if (this.tableConfig?.columns[columnCode]) {
        this.tableConfig.columns[columnCode].sort = sort
      } else {
        console.warn(`Column "${columnCode}" không tồn tại trong tableConfig`)
      }
    },

    //DATA ACTION
    async fetchList(){
      return new Promise((resolve, reject) => {
        try{
          this.action_type = MembershipActionTypes.FETCHING
          const sort = this.sortFilter
          const filter = {
            page: this.page,
            pageSize: this.pageSize,
            sort
          }

          // const res = APIClient.get(AccountAPI.list, {
          //   params: filter
          // })
          // setTimeout(()=>{
          //   this.data = {
          //     list: [
          //       {id: 1, status: 'Ngưng hoạt động', name: 'Premium', description: '', price: 300000, period: '30 ngày', created_at: '2025-05-01 00:00:00'},
          //     ],
          //     totalRecords: 100,
          //     totalPage: 10
          //   }
          //   this.action_type = MembershipActionTypes.FETCH_SUCCESS
          //   resolve(res)
          // }, 300)
        } catch (e) {
          this.action_type = MembershipActionTypes.FETCH_FAILURE
          reject(e)
        }
      })
    }
  }
})
